import React from "react";
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBIcon,
} from "mdb-react-ui-kit";

const BORDER_COLORS = ["primary", "warning", "info"];

const RorOption = ({ option, onSelectRor, borderColor }) => {
  const allIdentifiers = [
    ...(option?.acronyms || []),
    ...(option?.aliases || []),
    ...(option?.labels || []),
  ].filter((item) => typeof item === "string" && item.trim() !== "");

  const parentInfo =
    option?.parents && option.parents.length > 0
      ? `(child of ${option.parents.map((parent) => parent.name).join(", ")})`
      : "";

  const location = [option?.city, option?.country].filter(Boolean).join(", ");
  const identifierText = allIdentifiers.join(", ");

  return (
    <div
      className={`d-flex align-items-center gap-2 border-start border-3 border-${borderColor} ps-2 py-2`}
    >
      <div className="flex-grow-1" style={{ minWidth: 0 }}>
        <div className="fw-semibold" style={{ fontSize: "1rem", lineHeight: 1.3 }}>
          {option?.ror_name}
          {location && (
            <span className="fw-normal text-muted">{`, ${location}`}</span>
          )}
        </div>
        {identifierText && (
          <div
            className="text-muted text-truncate"
            style={{ fontSize: "0.875rem", lineHeight: 1.3 }}
            title={identifierText}
          >
            {identifierText}
          </div>
        )}
        <div className="text-truncate" style={{ fontSize: "0.875rem", lineHeight: 1.3 }}>
          <a
            href={option?.ror_id}
            target="_blank"
            rel="noreferrer"
            aria-label={`Link to ${option?.ror_name}`}
            className="text-decoration-none"
          >
            {option?.ror_id}
          </a>
          {parentInfo && (
            <span className="text-muted ms-1" title={parentInfo}>
              {parentInfo}
            </span>
          )}
        </div>
      </div>
      <MDBBtn
        size="sm"
        color={borderColor}
        className="d-inline-flex align-items-center justify-content-center p-0 flex-shrink-0"
        style={{ width: "1.8125rem", height: "1.8125rem", marginRight: "0.5rem" }}
        onClick={() => onSelectRor(option.ror_id)}
        aria-label={`Select ${option?.ror_name}`}
        title="Select"
      >
        <MDBIcon fas icon="check" />
      </MDBBtn>
    </div>
  );
};

export const SelectRorCard = ({ task, onSelectRor }) => {
  const location = [task.data?.city, task.data?.country].filter(Boolean).join(", ");

  return (
    <MDBCard className="mb-3 text-start">
      <MDBCardBody className="p-3">
        <div
          className="form-control py-2"
          style={{
            height: "auto",
            minHeight: "unset",
            fontSize: "1rem",
            lineHeight: 1.35,
          }}
        >
          {task.data?.affiliation}
        </div>
        {location && (
          <div className="text-muted mt-1" style={{ fontSize: "0.875rem" }}>
            {location}
          </div>
        )}
        {task.data?.address && (
          <div className="text-muted" style={{ fontSize: "0.875rem" }}>
            <span className="fw-bold">Address:</span> {task.data.address}
          </div>
        )}
        <div className="d-flex flex-column gap-2 mt-2">
          {task.data?.options?.map((option, index) => (
            <RorOption
              key={option.ror_id}
              option={option}
              onSelectRor={onSelectRor}
              borderColor={BORDER_COLORS[index % BORDER_COLORS.length]}
            />
          ))}
          <div>
            <MDBBtn size="sm" color="danger" onClick={() => onSelectRor(null)}>
              None of these
            </MDBBtn>
          </div>
        </div>
      </MDBCardBody>
    </MDBCard>
  );
};
